module.exports = __webpack_public_path__ + "img/dsg-transparent-long-logo.f1a0224b.png";